import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BottlingPlanHeader = ({ planId, onSave, saving }) => {
  const navigate = useNavigate();
  
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h2>{planId ? 'Edit Bottling Plan' : 'New Bottling Plan'}</h2>
      <div className="btn-group">
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => navigate('/bottling-plans')}
        >
          <ArrowLeft size={16} className="me-1" />
          Back to List
        </button>
        <button
          type="submit"
          className="btn btn-outline-primary btn-sm"
          disabled={saving}
          onClick={onSave}
        >
          {saving ? 'Saving...' : 'Save Plan'}
        </button>
      </div>
    </div>
  );
};

export default BottlingPlanHeader;